const styles = theme => ({
  titleWrapper: {
    borderBottom: '1px solid rgba(0,0,0,0.12)',
    marginBottom: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 3
  },
  pageTitle: {
    display: 'inline-flex'
  },
  body: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  sidebar: {
    width: '23.56%'
  },
  content: {
    width: '74.52%'
  },
  basicInformation: {
    paddingBottom: theme.spacing.unit * 0.2
  },
  actions: {
    padding: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 12,
    paddingBottom: theme.spacing.unit * 6,
    backgroundColor: theme.palette.background.default,
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    zIndex: 990
  },
  actionSave: {
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4
  },
  actionDraft: {
    marginRight: theme.spacing.unit * 1.875
  },
  cancelButtonContainer: {
    display: 'flex',
    float: 'right',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40px'
  },
  cancelButton: {
    textDecoration: 'none !important'
  },
  cancelActionLabel: {
    fontWeight: 500,
    color: theme.palette.primary.main
  },
  servicesEquipment: {
    marginBottom: theme.spacing.unit * 3
  },
  actionsPlaceholder: {
    padding: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 12,
    paddingBottom: theme.spacing.unit * 6,
    '&::before': {
      content: '""'
    }
  }
});

export default styles;
